import { render, staticRenderFns } from "./DeliveryNotesForm.vue?vue&type=template&id=40a0bdc6&scoped=true&"
import script from "./DeliveryNotesForm.vue?vue&type=script&lang=js&"
export * from "./DeliveryNotesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a0bdc6",
  null
  
)

export default component.exports